module.exports = __webpack_public_path__ + "media/country_flags/ba-49d72d80.png";